import React from 'react';
import {smartJump} from 'utils/utils';
import {inject, observer} from 'mobx-react';
import {IMG_PATH} from '../../constant';
import Layout from '../Layout';

import './index.scss';

@inject('store')
@observer
class Line extends React.Component {
    render() {
        const {whbdbq: data = [], bg = {}} = this.props.store.renderData;
        const {whbdMore = {}} = bg.data || {};

        if (!data.length) {
            return null;
        }
        return (
            <Layout
                id="whbdbq"
                className="m-line"
                titImg={`${IMG_PATH}/whbd.png`}
                displayLimit={6}
                moduleName="whbdcp"
                tabData={data}
                more={whbdMore}
                eidSuffix="bangdan"
                renderList={({list, tabName}) => {
                    return (
                        <div className="m-line-content">
                            {
                                list.map((v, k) => {
                                    const {price, taocanPrice, title, thumb, jumpInfo, ttsEnid} = v.data.product;
                                    return <div className="ml-item g-flexbox" key={k} data-sk-eid="list_bangdan" data-sk-edata={JSON.stringify({pid: ttsEnid, tabName})} onClick={() => {
                                        smartJump(jumpInfo.touchUrl, 'navibar-none');
                                    }}>
                                        <img className="img" src={thumb}></img>
                                        <div className="content flex">
                                            <div className="title">{title}</div>
                                            <div className="ft g-flexbox">
                                                <div className="price flex">￥<span className="num">{taocanPrice || price}</span>起</div>
                                            </div>
                                        </div>
                                    </div>;
                                })
                            }
                        </div>
                    );
                }}
            />
        );
    }
}

export default Line;